import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const DragHandleIcon = React.memo<IconProps>(
  ({ className = '', size = 16, width, height, color = 'currentColor', onClick }) => (
    <BaseIcon
      className={className}
      size={size}
      width={width ?? 10}
      height={height ?? 18}
      color={color}
      onClick={onClick}
      viewBox="0 0 10 18"
    >
      <circle cx="5" cy="2" r="1" fill={color} />
      <circle cx="5" cy="5" r="1" fill={color} />
      <circle cx="5" cy="8" r="1" fill={color} />
      <circle cx="5" cy="11" r="1" fill={color} />
      <circle cx="5" cy="14" r="1" fill={color} />
    </BaseIcon>
  ),
);

DragHandleIcon.displayName = 'DragHandleIcon';
